/**
 * Compares two values for sorting purposes, handling null and undefined values.
 * @param valueA First value to compare
 * @param valueB Second value to compare
 * @returns -1 if valueA < valueB, 1 if valueA > valueB, 0 if equal
 */
export const compareValues = <T>(
  valueA: T | undefined | null,
  valueB: T | undefined | null
): number => {
  if ((valueA === undefined || valueA === null) && (valueB === undefined || valueB === null)) {
    return 0;
  }

  if (valueA === undefined || valueA === null) {
    return -1;
  }

  if (valueB === undefined || valueB === null) {
    return 1;
  }

  if (typeof valueA === 'string' && typeof valueB === 'string') {
    return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
  }

  if (valueA < valueB) return -1;
  if (valueA > valueB) return 1;
  return 0;
};

/**
 * Applies a sort direction to a comparison result.
 * @param comparisonResult Result from compareValues (-1, 0, or 1)
 * @param direction Sort direction ('asc' or 'desc')
 * @returns Modified comparison result with direction applied
 */
export const applyDirection = (comparisonResult: number, direction: 'asc' | 'desc'): number => {
  return direction === 'asc' ? comparisonResult : -comparisonResult;
};
